import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useSubscription } from './SubscriptionContext';
import Loader from './components/Loader';

const ProtectedRoute = ({ children }) => {
  const { isUserLoggedIn, isLoading, login } = useAuth();
  const { hasSubscription, isLoading: subscriptionLoading } = useSubscription();
  const location = useLocation();
  const navigate = useNavigate(); // Add navigate for redirection
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const checkForSharedSession = async () => {
      if (sessionStorage.getItem("authToken")) {
        setIsInitializing(false);
        return;
      }

      try {
        localStorage.setItem('requestAuthToken', Date.now().toString());
        await new Promise(resolve => setTimeout(resolve, 300));

        const token = sessionStorage.getItem("authToken");
        if (token) {
          const userId = localStorage.getItem("userId");
          login(token, userId);
        }
      } catch (error) {
        console.error("Error checking for shared session:", error);
      } finally {
        localStorage.removeItem('requestAuthToken');
        setIsInitializing(false);
      }
    };

    checkForSharedSession();

    const handleStorage = (event) => {
      if (event.key === 'shareAuthToken' && event.newValue) {
        sessionStorage.setItem('authToken', event.newValue);
        const userId = localStorage.getItem("userId");
        login(event.newValue, userId);
      }

      if (event.key === 'logoutEvent') {
        console.log("Logout detected via storage event");
        sessionStorage.removeItem('authToken');
        localStorage.removeItem('authToken');
        navigate('/', { replace: true }); // ⬅️ redirect to login
      }
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
    };
  }, [login, navigate]);

  if (isLoading || isInitializing || subscriptionLoading) {
    return <Loader />;
  }

  const authTokenExists = !!sessionStorage.getItem("authToken");

  if (!isUserLoggedIn && !authTokenExists) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
